import React, { Component } from 'react'
import ProductItem from './ProductItem'
import { getGoodList } from '@/apis/share.ts'
import appInstall from '@/utils/appUtils/appInstall'

import { copyText, formatMoney } from '@/utils/index'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import { Toast } from 'antd-mobile'
import { EditConfigType, GlobalConfigType } from '@/typings/types'
import styles from '../index.module.less'
// import imgResize from '@/utils/img-resize'
import { currencySymbolMap } from '@/constant'
import ProductTitle from '@/common/productTitle'

const imgFilter = (value, size) => {
  return `${value}?x-oss-process=image/resize,m_pad,h_${size},w_${size}`
}

interface IProductWrapperProps {
  editConfig?: EditConfigType
  categoryId?: number
  tabItemTitleBg?: string
  tabItemTitleLeftBg?: string
  tabItemTitleRightBg?: string
  titleBgImgType?: number
  globalConfig?: GlobalConfigType
  pageId?: string
  tabBarActiveTextColor?: string
  groupName?: string
  spuIds?: string
  spuIdType: string
}

class Index extends Component<IProductWrapperProps> {
  static config = {
    name: 'poizon-newProductFlow',
  }

  state = {
    list: [],
  }
  componentDidMount() {
    this.getGoodList()
  }

  getCurrency = () => {
    const local = this.props.editConfig.local
    return currencySymbolMap[local]
  }

  getGoodList = async () => {
    const { lang, local } = this.props?.editConfig
    const spuIdType = this.props.spuIdType
    const key = spuIdType === 'SPUID' ? 'spuIdInfo' : 'itemInfo'
    const spuIds = (this.props.spuIds ?? '').split(',').map((item, index) => {
      const key = spuIdType === 'SPUID' ? 'spuId' : 'itemNum'
      return {
        index,
        [key]: `${item}`.trim(),
      }
    })
    try {
      const { status, data } = await getGoodList({
        [key]: JSON.stringify(spuIds),
        countryCode: local,
        language: lang,
      })
      if (status === 200) {
        this.setState({
          list: data.children,
        })
      }
    } catch (error) {
      console.error('error', error)
    }
  }

  handleCover(url) {
    const newUrl = (url += imgFilter('', 200))
    return newUrl
  }

  goDetail = (params, itemNo) => {
    const { spuId } = params
    if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
      Jockeys.openNativePage('/sell/productDetail', {
        spuId,
      })
      return
    }

    if (isDuApp()) {
      const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
      copyText(itemNo)
      Toast.info(msg)
      return
    }
    appInstall('/sell/productDetail', { spuId })
  }

  render() {
    const list = this.state.list
    const {
      tabItemTitleBg,
      tabItemTitleLeftBg,
      tabItemTitleRightBg,
      globalConfig,
      titleBgImgType,
      pageId,
    } = this.props

    return (
      <div className={styles.group}>
        <ProductTitle
          tabItemTitleBg={tabItemTitleBg}
          tabItemTitleLeftBg={tabItemTitleLeftBg}
          tabItemTitleRightBg={tabItemTitleRightBg}
          tabBarActiveTextColor={this.props.tabBarActiveTextColor}
          title={this.props.groupName}
          titleBgImgType={titleBgImgType}
        />
        <div className={styles.desc}>
          {list.map(({ itemNo, cover, spuId, title, price, showPrice }, index) => (
            <ProductItem
              itemNo={itemNo}
              index={index}
              cover={cover}
              spuId={spuId}
              title={title}
              price={price}
              handleCover={this.handleCover}
              handlePrice={formatMoney}
              getCurrency={this.getCurrency}
              goDetail={this.goDetail}
              globalConfig={globalConfig}
              pageId={pageId}
              key={spuId}
              showPrice={showPrice}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default Index
